"use client";

import type { Route } from "next";
import Link from "next/link";
import { useListReturnHref } from "@/features/common/list-return-provider";

/**
 * A plain `Link` to a list that opens the URL the member last used on this
 * device. `href` is the bare list path and the fallback. Use `ListBackLink`
 * for the breadcrumb-style link of detail pages; use this one where a link
 * has its own look, such as a `render` prop or an outline button.
 *
 * `variant="sidebar"` drops the page cursor and fixed dates.
 */
export function ListReturnLink({
  href,
  variant = "back",
  ...props
}: Omit<React.ComponentProps<typeof Link>, "href"> & {
  href: string;
  variant?: "back" | "sidebar";
}) {
  const resolvedHref = useListReturnHref(href, variant);
  return <Link {...props} href={resolvedHref as Route} />;
}
